import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-information-dialog',
  templateUrl: 'information-dialog.component.html',
  styleUrls: ['information-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InformationDialogComponent implements OnInit {
  title?: string;
  firstColumnTitle?: string;
  secondColumnTitle?: string;
  firstColumn: string[] = [];
  secondColumn: string[] = [];
  closeButton = false;

  constructor(
    public dialogRef: MatDialogRef<InformationDialogComponent>,
    public overlayLoader: OverlayLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.firstColumnTitle = this.data.firstColumnTitle;
    this.secondColumnTitle = this.data.secondColumnTitle;
    this.firstColumn = this.data.firstColumn;
    this.secondColumn = this.data.secondColumn;
    this.closeButton = this.data.closeButton;
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
